import { Action } from '@ngrx/store';
import { AppState } from './app.state';

export const initialState: AppState = {
  auth: null,
  shoppingCart: null,
  regData: {
    version: 1.00,
    regId: null,
    selectedTestPurposeOption: null,
    testSession: null,
    proofOfIdentity: null,
    scoreReport: null,
    lookup: {
      testPurposes: [],
      institutions: [],
      subscribedInstitutions: null,
    }
  },
  myAccount: null,
  businessAccountParentKey: null,
  redirectUrl: null
};


export const resetStoreReducer = (reducer: any) => (state: AppState, action: Action) => {
  if (action.type === 'Reset Store') {
    return reducer(initialState, action);
  }
  return reducer(state, action);
};

